import { useMemo } from "react";
import { useBundleFile } from "@/raw-files-viewer/useBundleFile";

interface CorrectionPageImageProps {
  rawBundleId: string;
  pageKey: string;
}

export function CorrectionPageImage({ rawBundleId, pageKey }: CorrectionPageImageProps) {
  const { data, isLoading, error } = useBundleFile(rawBundleId, pageKey, true);
  const src = useMemo(() => (data?.type === "png" ? `data:image/png;base64,${data.content}` : null), [data]);

  if (isLoading) return <div className="py-8 text-center text-sm text-muted-foreground">Loading page…</div>;
  if (error) return <div className="py-8 text-center text-destructive">{error.message}</div>;
  if (!src) return <div className="py-8 text-center text-sm text-muted-foreground">This page is not an image.</div>;

  return <img src={src} alt={pageKey} className="max-w-full" />;
}
